import { Component, forwardRef, Input, ViewChild } from '@angular/core';
import { ControlContainer, DefaultValueAccessor, FormGroupDirective, NG_VALUE_ACCESSOR } from '@angular/forms';
import { HappyInputBase } from '../happy-template-input/happy-input-base';

export const TEXT_INPUT_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => TextInputComponent),
    multi: true,
};

@Component({
    selector: 'itpx-text-input',
    templateUrl: './text-input.component.html',
    styleUrls: ['./text-input.component.css', '../styles.css'],
    viewProviders: [{provide: ControlContainer, useExisting: FormGroupDirective}],
    providers: [TEXT_INPUT_VALUE_ACCESSOR]
})
export class TextInputComponent extends HappyInputBase {

    @ViewChild(DefaultValueAccessor) private valueAccessor: DefaultValueAccessor;

    @Input() placeholder: string;
    @Input() dataHjSupress: boolean = false;

    constructor(parentForm: FormGroupDirective) {
        super(parentForm);
    }

    ngOnInit() {
        this.form = this.parentForm.form;
    }

    writeValue(obj: any) {
        this.valueAccessor.writeValue(obj);
    }

    registerOnChange(fn: any) {
        this.valueAccessor.registerOnChange(fn);
    }

    registerOnTouched(fn: any) {
        this.valueAccessor.registerOnTouched(fn);
    }

    setDisabledState(isDisabled: boolean) {
        this.valueAccessor.setDisabledState(isDisabled);
    }
}



// WEBPACK FOOTER //
// ./src/app/phoenix2/common/components/text-input/text-input.component.ts